module.exports = __webpack_public_path__ + "static/media/public_dashboard.0796a647.svg";